import { c as _c } from "react/compiler-runtime";
import { activeBulkSelector } from '@lib/store/slices/VisualBulkSlice';
import { activeFloorSelector } from '@lib/store/slices/VisualFlatSlice';
import { useParams } from 'next/navigation';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import ListLink from 'src/app/visual/components/visual-bottom-links/ListLink/ListLink';
import styles from './VisualGeneralInfo.module.scss';
const STAGE_NUMBER = {
  1: 'I',
  2: 'II'
};
const SECTIONS_NAME = {
  one: 'секция',
  few: 'секции',
  many: 'секций'
};
const FLOORS_NAME = {
  one: 'этаж',
  few: 'этажа',
  many: 'этажей'
};
const pluralRules = new Intl.PluralRules('ru-RU');
const formatSections = (initialName, count) => {
  const rule = pluralRules.select(count);
  return `${count} ${initialName[rule]}`;
};
const VisualGeneralInfoQueue = t0 => {
  const $ = _c(8);
  const {
    price
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className={styles.title}>Выберите <br /> очередь</p>;
    t2 = <div className={styles.crossline} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p>Квартиры от:</p>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== price) {
    t4 = <div className={styles.description}>{t3}<p>{price} ₽</p></div>;
    $[3] = price;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={styles.crossline} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <>{t1}{t2}{t4}{t5}</>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};
const VisualGeneralInfoBulk = t0 => {
  const $ = _c(22);
  const {
    price,
    buildingPhase,
    sectionsCount,
    flatsCount
  } = t0;
  const currentBuildingPhase = `${STAGE_NUMBER[buildingPhase]} очередь`;
  let t1;
  if ($[0] !== sectionsCount) {
    t1 = formatSections(SECTIONS_NAME, sectionsCount);
    $[0] = sectionsCount;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentSectionsCount = t1;
  let t2;
  if ($[2] !== currentBuildingPhase) {
    t2 = <p className={styles.title}>{currentBuildingPhase}</p>;
    $[2] = currentBuildingPhase;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.crossline} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p>Количество секций</p>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== currentSectionsCount) {
    t5 = <div className={styles.description}>{t4}<p>{currentSectionsCount}</p></div>;
    $[6] = currentSectionsCount;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={styles.crossline} />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p>Квартир в продаже</p>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== flatsCount) {
    t8 = <div className={styles.description}>{t7}<p>{flatsCount}</p></div>;
    $[10] = flatsCount;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className={styles.crossline} />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p>Квартиры от:</p>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== price) {
    t11 = <div className={styles.description}>{t10}<p>{price} ₽</p></div>;
    $[14] = price;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className={styles.crossline} />;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t11 || $[18] !== t2 || $[19] !== t5 || $[20] !== t8) {
    t13 = <>{t2}{t3}{t5}{t6}{t8}{t9}{t11}{t12}</>;
    $[17] = t11;
    $[18] = t2;
    $[19] = t5;
    $[20] = t8;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
};
const VisualGeneralInfoFloor = t0 => {
  const $ = _c(22);
  const {
    price,
    bulkMaxFloor,
    bulkNumber,
    flatsCount
  } = t0;
  const currentBulkSection = `Корпус ${bulkNumber}`;
  let t1;
  if ($[0] !== bulkMaxFloor) {
    t1 = formatSections(FLOORS_NAME, bulkMaxFloor);
    $[0] = bulkMaxFloor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentFloorsCount = t1;
  let t2;
  if ($[2] !== currentBulkSection) {
    t2 = <p className={styles.title}>{currentBulkSection}</p>;
    $[2] = currentBulkSection;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.crossline} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p>Количество этажей</p>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== currentFloorsCount) {
    t5 = <div className={styles.description}>{t4}<p>{currentFloorsCount}</p></div>;
    $[6] = currentFloorsCount;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={styles.crossline} />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p>Квартир в продаже</p>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== flatsCount) {
    t8 = <div className={styles.description}>{t7}<p>{flatsCount}</p></div>;
    $[10] = flatsCount;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className={styles.crossline} />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p>Квартиры от:</p>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== price) {
    t11 = <div className={styles.description}>{t10}<p>{price} ₽</p></div>;
    $[14] = price;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className={styles.crossline} />;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t11 || $[18] !== t2 || $[19] !== t5 || $[20] !== t8) {
    t13 = <>{t2}{t3}{t5}{t6}{t8}{t9}{t11}{t12}</>;
    $[17] = t11;
    $[18] = t2;
    $[19] = t5;
    $[20] = t8;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
};
const VisualGeneralInfoFlat = t0 => {
  const $ = _c(15);
  const {
    floor,
    bulk,
    queue
  } = t0;
  const currentFloor = `Этаж ${floor}`;
  const currentQueue = `Очередь ${STAGE_NUMBER[queue]}`;
  let t1;
  if ($[0] !== currentFloor) {
    t1 = <p className={styles.title}>{currentFloor}</p>;
    $[0] = currentFloor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles.crossline} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p>Корпус</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== bulk) {
    t4 = <div className={styles.description}>{t3}<p>{bulk}</p></div>;
    $[4] = bulk;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={styles.crossline} />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p>Очередь</p>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== currentQueue) {
    t7 = <div className={styles.description}>{t6}<p>{currentQueue}</p></div>;
    $[8] = currentQueue;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className={styles.crossline} />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t1 || $[12] !== t4 || $[13] !== t7) {
    t9 = <>{t1}{t2}{t4}{t5}{t7}{t8}</>;
    $[11] = t1;
    $[12] = t4;
    $[13] = t7;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};
const VisualGeneralInfo = ({
  type,
  flats,
  bulkIds = [],
  sectionsCount,
  buildingPhase
}) => {
  const {
    bulkId,
    houseId,
    floorId
  } = useParams();
  const activeBulk = useSelector(activeBulkSelector);
  const activeFloor = useSelector(activeFloorSelector) ?? floorId;
  const activeBulkId = Number(activeBulk?.split('_').slice(2)?.join('_')) || +bulkId;
  const currentBulk = flats?.find(flat => flat.bulk.id === activeBulkId);
  const currentBulkNumber = currentBulk?.bulk?.number;
  const currentBulkMaxFloor = currentBulk?.section?.floorsCount;
  const minimumFlat = useMemo(() => {
    if (!flats?.length) return null;
    return flats.filter(flat_0 => {
      if (type === 'queue' || type === 'bulks') return bulkIds.includes(flat_0.bulk.id);
      if (type === 'floor') return flat_0.bulk.id === activeBulkId;
      return flat_0;
    }).reduce((minFlat, flat_1, _, self) => {
      const normalizePrice = typeof flat_1.price === 'string' ? Number(flat_1.price.replace(/\s+/g, '')) : flat_1.price;
      if (!minFlat) return {
        ...flat_1,
        _normalizedPrice: normalizePrice
      };
      return normalizePrice < minFlat._normalizedPrice ? {
        ...flat_1,
        _normalizedPrice: normalizePrice,
        flatsCount: self.length
      } : minFlat;
    }, null);
  }, [flats, bulkIds]);
  const componentGeneralInfo = {
    queue: <VisualGeneralInfoQueue price={minimumFlat?.textPrice} />,
    bulks: <VisualGeneralInfoBulk price={minimumFlat?.textPrice} buildingPhase={buildingPhase} sectionsCount={sectionsCount} flatsCount={minimumFlat?.flatsCount} />,
    flat: <VisualGeneralInfoFlat floor={activeFloor} bulk={currentBulkNumber} queue={houseId} />,
    floor: <VisualGeneralInfoFloor price={minimumFlat?.textPrice} flatsCount={minimumFlat?.flatsCount} bulkNumber={currentBulkNumber} bulkMaxFloor={currentBulkMaxFloor} />
  };
  return <div className={styles.root}>
      <div className={styles.container}>
        {componentGeneralInfo[type]}
        <div className={styles.link}>
          <ListLink color='white' />
        </div>
      </div>
    </div>;
};
export default VisualGeneralInfo;